import { useMediaQuery, useTheme } from '@mui/material';

/**
 * Returns true when viewport is below 'md' breakpoint (< 900px).
 * Use for tablet and phone layouts (hide sidebar, show drawer, etc.)
 */
export const useIsMobile = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
};

/**
 * Returns true when viewport is below 'sm' breakpoint (< 600px).
 * Use for phone-specific layouts (fullscreen dialogs, card views, etc.)
 */
export const useIsPhone = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
};
